import {
  cilSpeedometer,
  cilLayers,
  cilBasket,
  cilBadge,
  cilBolt,
  cilBook,
  cilGift,
  cilTags,
  cilPuzzle,
  cilGrain,
} from "@coreui/icons";
import { routePaths } from "../../routes/route-paths";

export interface NavItem {
  to: string;
  labelKey: string; // i18n key under common:navigation
  icon: unknown[]; // CoreUI icon shape
  end?: boolean;
  /** Left out where memberships are hidden. */
  membershipsOnly?: boolean;
  /** Left out where the portfolio builder is switched off. */
  portfolioBuilderOnly?: boolean;
  /** A pill after the label, i18n key under common:navigationBadges. */
  badgeKey?: string;
}

export interface NavSection {
  key: string;
  /** i18n key under common:navigationSections. Omitted for the untitled group Dashboard sits in. */
  titleKey?: string;
  items: NavItem[];
}

// Grouped the way the back office's sidebar is, and ordered as the journey: look around (memberships first,
// since they're what we lead with), then what's yours.
export const navSections: NavSection[] = [
  {
    key: "home",
    items: [
      {
        to: routePaths.dashboard,
        labelKey: "dashboard",
        icon: cilSpeedometer,
        end: true,
      },
    ],
  },
  {
    key: "explore",
    titleKey: "explore",
    items: [
      {
        to: routePaths.memberships,
        labelKey: "memberships",
        icon: cilBadge,
        membershipsOnly: true,
      },
      {
        to: routePaths.strategies,
        labelKey: "strategies",
        icon: cilLayers,
      },
      {
        to: routePaths.portfolioBuilder,
        labelKey: "portfolioBuilder",
        icon: cilGrain,
        portfolioBuilderOnly: true,
        badgeKey: "new",
      },
      {
        to: routePaths.addOns,
        labelKey: "addOns",
        icon: cilPuzzle,
      },
    ],
  },
  {
    key: "yours",
    titleKey: "yours",
    items: [
      {
        to: routePaths.myStrategies,
        labelKey: "myStrategies",
        icon: cilBasket,
      },
      // Shown to everyone: with nothing unlocked, the page says how signals start.
      {
        to: routePaths.signals,
        labelKey: "signals",
        icon: cilBolt,
      },
      {
        to: routePaths.offers,
        labelKey: "offers",
        icon: cilTags,
      },
    ],
  },
  {
    key: "more",
    titleKey: "more",
    items: [
      {
        to: routePaths.partnerOffers,
        labelKey: "partners",
        icon: cilGift,
      },
      // One entry, permanently. Articles are discovered by browsing and search on
      // the help index — the sidebar does not grow as content does.
      {
        to: routePaths.help,
        labelKey: "help",
        icon: cilBook,
      },
    ],
  },
];
